import styled from 'styled-components';
import theme from '../../../styles/defaultTheme';

export const Container = styled.div`
  position: relative;

  display: flex;
  align-items: center;

  width: 100%;
  min-width: 100px;
  height: 44px;

  cursor: default;

  border-radius: 8px;
  outline: none;

  border: 1px solid
    ${({ isOnFocus }) => (isOnFocus ? (props) => props.theme.orangeLink : (props) => props.theme.lightGreyLink40)};

  background: ${(props) => props.theme.white};
  color: #1a171b;
  font-size: ${theme.font.size16};

  transition: all 0.3s;

  &.error {
    border: 1px solid ${(props) => props.theme.redLink};
  }

  &:hover:not(.error):not(.disabled) {
    border: 1px solid ${(props) => props.theme.orangeLink}
  }

  ${({ disabled, theme: propsTheme }) =>
      disabled &&
      `
    
            background: ${propsTheme.disabledGrey10};
            cursor: not-allowed;
            color: ${propsTheme.lightGreyLink40};
        `}

  & .MuiBadge-root {
    position: absolute;
    right: 60px;

    & .MuiBadge-colorPrimary {
      background-color: ${(props) => props.theme.greyToBlack} !important;
      border: 1px solid  ${(props) => props.theme.borderWhite};
    }
  }

  & > div:first-child {
    position: absolute;
    padding: 0 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 90px;
    max-width: 100%;
    color: ${(props) => props.theme.blackLink};
  }
`;

export const ContainerOptions = styled.div`
  width: 100%;

  max-height: 270px;
  overflow-y: auto;

  position: absolute;
  border: 1px solid ${(props) => props.theme.lightGrey40};

  box-shadow: rgb(0 0 0 / 20%) 0px 5px 5px -3px,
    rgb(0 0 0 / 14%) 0px 8px 10px 1px, rgb(0 0 0 / 12%) 0px 3px 14px 2px;

  ${({ isOnFocus }) => !isOnFocus && `display: none;`}

  ${({ optionsPosition }) => `top: ${optionsPosition}px;`}

    background: ${(props) => props.theme.white};
  border-radius: 8px;

  z-index: 1000;

  & > div {
    padding: 0 16px;
    margin: 16px 0 24px 0;

    & label {
      margin: 0;
    }
  }

  & ul {
    list-style: none;

    margin: 0;
    padding: 0;
  }

  & li {
    display: flex;
    align-items: center;

    transition: 0.2s;
    font-size: ${theme.font.size16};

    padding: 8px 16px;

    &:hover {
      background: ${(props) => props.theme.hoverOrangeTransparent};
      cursor: pointer;
    }

    &.no-data-found {
      opacity: 0.7;
    }

    & .MuiSvgIcon-root {
      font-size: ${theme.font.size17};
      margin-right: 10px;
    }
  }
`;

export const BagdeText = styled.div`
  font: ${theme.font.body[5]};
  color: ${(props) => props.theme.whiteToWhite};
`;

export const SelectText = styled.div`
  color: ${(props) => props.theme.blackLink};
`;
